import Home from '../modules/index/index.vue';
/**
 * @file 路由信息
 * @author hardylin <hardylin@tencent.com>
 */
export default [{
    name: 'index',
    path: '/',
    component: Home,
    meta: {
        name: '首页', // PV 上报使用
    }
}, {
    name: 'notice',
    path: '/notice',
    component: () => import(/* webpackChunkName: 'notice' */ '../modules/index/notice.vue'),
    meta: {
        name: '官方公告'
    }
}, {
    name: 'moment',
    path: '/moment',
    component: () => import(/* webpackChunkName: 'moment' */ '../modules/moment/index.vue'),
    meta: {
        name: '动态'
    }
}, {
    name: 'moment-submit',
    path: '/moment/submit',
    component: () => import(/* webpackChunkName: 'moment-submit' */ '../modules/moment/submit.vue'),
    meta: {
        name: '动态-发布'
    }
}, {
    name: 'moment-group',
    path: '/moment/group',
    component: () => import(/* webpackChunkName: 'moment-group' */ '../modules/moment/group/list.vue'),
    meta: {
        name: '动态-群组列表'
    }
}, {
    name: 'moment-group-detail',
    path: '/moment/group/:id',
    component: () => import(/* webpackChunkName: 'moment-group-detail' */ '../modules/moment/group/detail.vue'),
    meta: {
        name: '动态-群组详情'
    }
}, {
    name: 'moment-topic',
    path: '/moment/topic',
    component: () => import(/* webpackChunkName: 'moment-topic' */ '../modules/moment/topic/list.vue'),
    meta: {
        name: '动态-话题列表'
    }
}, {
    name: 'moment-topic-detail',
    path: '/moment/topic/:id',
    component: () => import(/* webpackChunkName: 'moment-topic-detail' */ '../modules/moment/topic/detail.vue'),
    meta: {
        name: '动态-话题详情'
    }
}, {
    name: 'moment-collection',
    path: '/moment/collection',
    component: () => import(/* webpackChunkName: 'moment-collection' */ '../modules/moment/collection/list.vue'),
    meta: {
        name: '动态-内容合辑列表'
    }
}, {
    name: 'moment-collection-detail',
    path: '/moment/collection/:id',
    component: () => import(/* webpackChunkName: 'moment-collection-detail' */ '../modules/moment/collection/detail.vue'),
    meta: {
        name: '动态-内容合辑详情'
    }
}, {
    name: 'moment-user-ranking',
    path: '/moment/user/ranking',
    component: () => import(/* webpackChunkName: 'moment-user-ranking' */ '../modules/moment/user/ranking.vue'),
    meta: {
        name: '动态-用户排行'
    }
}, {
    name: 'moment-recommend',
    path: '/moment/recommend',
    component: () => import(/* webpackChunkName: 'moment-recommend' */ '../modules/moment/recommend/list.vue'),
    meta: {
        name: '动态-用户推荐'
    }
}, {
    name: 'moment-detail-article',
    path: '/moment/detail/article/:id',
    component: () => import(/* webpackChunkName: 'moment-detail-article' */ '../modules/moment/detail/article.vue'),
    meta: {
        name: '动态-图文详情'
    }
}, {
    name: 'moment-detail-video',
    path: '/moment/detail/video/:id',
    component: () => import(/* webpackChunkName: 'moment-detail-video' */ '../modules/moment/detail/video.vue'),
    meta: {
        name: '动态-视频详情'
    }
}, {
    name: 'moment-detail-notice',
    path: '/moment/detail/notice/:id',
    component: () => import(/* webpackChunkName: 'moment-detail-notice' */ '../modules/moment/detail/notice.vue'),
    meta: {
        name: '动态-群组公告'
    }
}, {
    name: 'doujin',
    path: '/doujin',
    component: () => import(/* webpackChunkName: 'doujin' */ '../modules/colleagues/index.vue'),
    meta: {
        name: '同人'
    }
}, {
    name: 'doujin-detail-article',
    path: '/colleagues/details/:id',
    component: () => import(/* webpackChunkName: 'doujin-detail-article' */ '../modules/colleagues/details.vue'),
    meta: {
        name: '同人-图文详情'
    }
}, {
    name: 'doujin-detail-video',
    path: '/colleagues/video/:id',
    component: () => import(/* webpackChunkName: 'doujin-detail-video' */ '../modules/colleagues/video.vue'),
    meta: {
        name: '同人-视频详情'
    }
}, {
    name: 'playbook',
    path: '/playbook',
    component: () => import(/* webpackChunkName: 'playbook' */ '../modules/playbook/index.vue'),
    meta: {
        name: '攻略'
    }
}, {
    name: 'label',
    path: '/label/:category/:subcategory',
    component: () => import(/* webpackChunkName: 'label' */ '../modules/playbook/label/index.vue'),
    meta: {
        name: '标签列表'
    }
}, {
    name: 'label-detail',
    path: '/detail/label/:label',
    component: () => import(/* webpackChunkName: 'label-detail' */ '../modules/playbook/label/detail.vue'),
    meta: {
        name: '标签详情'
    }
}, {
    name: 'video',
    path: '/video',
    component: () => import(/* webpackChunkName: 'video' */ '../modules/video/index.vue'),
    meta: {
        name: '视频'
    }
}, {
    name: 'bbs',
    path: '/bbs',
    component: () => import(/* webpackChunkName: 'bbs' */ '../modules/bbs/index.vue'),
    meta: {
        name: '论坛'
    }
}, {
    name: 'me',
    path: '/me',
    component: () => import(/* webpackChunkName: 'me' */ '../modules/me/index.vue'),
    meta: {
        name: '我的'
    }
}, {
    name: 'message',
    path: '/message',
    component: () => import(/* webpackChunkName: 'message' */ '../modules/me/message.vue'),
    meta: {
        name: '消息中心'
    }
}, {
    name: 'favorites',
    path: '/favorites',
    component: () => import(/* webpackChunkName: 'favorites' */ '../modules/me/favorites.vue'),
    meta: {
        name: '我的收藏'
    }
}, {
    name: 'subscribe',
    path: '/subscribe',
    component: () => import(/* webpackChunkName: 'favorites' */ '../modules/me/subscribe.vue'),
    meta: {
        name: '我的订阅'
    }
}, {
    name: 'browse',
    path: '/browse',
    component: () => import(/* webpackChunkName: 'browse' */ '../modules/me/browse.vue'),
    meta: {
        name: '最近浏览'
    }
}, {
    name: 'user',
    path: '/user',
    component: () => import(/* webpackChunkName: 'user' */ '../modules/me/user.vue'),
    meta: {
        name: '个人中心'
    }
}, {
    name: 'me-info',
    path: '/me/info',
    component: () => import(/* webpackChunkName: 'home' */ '../modules/me/home.vue'),
    meta: {
        name: '个人信息-主态'
    }
}, {
    name: 'guest-info',
    path: '/guest/info/:id',
    component: () => import(/* webpackChunkName: 'home' */ '../modules/me/home.vue'),
    meta: {
        name: '个人信息-客态'
    }
}, {
    name: 'follow',
    path: '/attention',
    component: () => import(/* webpackChunkName: 'follow' */ '../modules/colleagues/attentionList.vue'),
    meta: {
        name: '我的关注-主态'
    }
}, {
    name: 'follow',
    path: '/attention/:id',
    component: () => import(/* webpackChunkName: 'follow' */ '../modules/colleagues/attentionList.vue'),
    meta: {
        name: '我的关注-客态'
    }
}, {
    name: 'fans',
    path: '/follower',
    component: () => import(/* webpackChunkName: 'fans' */ '../modules/colleagues/followerList.vue'),
    meta: {
        name: '粉丝列表-主态'
    }
}, {
    name: 'fans',
    path: '/follower/:id',
    component: () => import(/* webpackChunkName: 'fans' */ '../modules/colleagues/followerList.vue'),
    meta: {
        name: '粉丝列表-客态'
    }
}, {
    name: 'search',
    path: '/search',
    component: () => import(/* webpackChunkName: 'search' */ '../modules/search/index.vue'),
    meta: {
        name: '搜索'
    }
}, {
    name: 'detail-news',
    path: '/detail/news/:id',
    component: () => import(/* webpackChunkName: 'detail-news' */ '../module/detail/news.vue'),
    meta: {
        name: '资讯详情'
    }
}, {
    name: 'detail-video',
    path: '/detail/video/:id',
    component: () => import(/* webpackChunkName: 'detail-video' */ '../module/detail/video.vue'),
    meta: {
        name: '视频详情'
    }
}, {
    name: 'detail-short',
    path: '/detail/short/:id',
    component: () => import(/* webpackChunkName: 'detail-short' */ '../module/detail/short.vue'),
    meta: {
        name: '短攻略详情'
    }
}, {
    name: 'user-guest',
    path: '/user/:id',
    component: () => import(/* webpackChunkName: 'user-guest' */ '../module/user/guest.vue'),
    meta: {
        name: '玩家主页-客态'
    }
}, {
    name: 'comment',
    path: '/comment',
    component: () => import(/* webpackChunkName: 'comment' */ '../module/comment/comment.vue'),
    meta: {
        name: '视频详情'
    }
}, {
    name: 'submit',
    path: '/submit',
    component: () => import(/* webpackChunkName: 'submit' */ '../module/submit/short.vue'),
    meta: {
        name: '发表短攻略'
    }
}, {
    name: 'submitId',
    path: '/submit/:id',
    component: () => import(/* webpackChunkName: 'submit' */ '../module/submit/short.vue'),
    meta: {
        name: '发表短攻略-id'
    }
}, {
    name: 'submit-id-tags',
    path: '/submit/:id/:isShowTags',
    component: () => import(/* webpackChunkName: 'submit' */ '../module/submit/short.vue'),
    meta: {
        name: '发表短攻略-id-isShowTags'
    }
}, {
    name: 'qa',
    path: '/qa/find',
    component: () => import(/* webpackChunkName: 'slug-qa' */ '../modules/qa/index.vue'),
    meta: {
        name: '问答-发现'
    }
}, {
    name: 'qa-detail',
    path: '/qa/detail/:id',
    component: () => import(/* webpackChunkName: 'slug-qa' */ '../modules/qa/detail.vue'),
    meta: {
        name: '问答-详情'
    }
}, {
    name: 'qa-share',
    path: '/qa/share/:id',
    component: () => import(/* webpackChunkName: 'slug-qa' */ '../modules/qa/share.vue'),
    meta: {
        name: '问答-详情'
    }
}, {
    name: 'qa-center',
    path: '/qa/center/:tpl',
    component: () => import(/* webpackChunkName: 'slug-qa' */ '../modules/qa/center.vue'),
    meta: {
        name: '问答-消息中心'
    }
}]
